import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';

/**
 * Arranque del **portal del cliente**.
 *
 * A diferencia del panel, aquí no hay `SessionProvider` que registrar: el portal
 * no usa el token del operador ni su refresco. Su token viaja en las cabeceras
 * que arma `portal.api.ts` a partir del store del portal (`scope: 'cliente'`).
 */
const container = document.getElementById('root');

if (!container) {
  throw new Error('No se encontró el elemento #root en index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
